var _path, _path2, _rect;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProfiledropdownHelpcenter(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "interrogation",
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_54373",
    "data-name": "Path 54373",
    d: "M9,0a9,9,0,1,0,9,9A9,9,0,0,0,9,0ZM9,16.5A7.5,7.5,0,1,1,16.5,9,7.5,7.5,0,0,1,9,16.5Z",
    transform: "translate(0 0)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_54374",
    "data-name": "Path 54374",
    d: "M11.538,5.047A3,3,0,0,0,8,8,.75.75,0,0,0,9.5,8a1.5,1.5,0,0,1,1.778-1.475,1.518,1.518,0,0,1,1.2,1.2,1.5,1.5,0,0,1-.75,1.594,2.965,2.965,0,0,0-1.478,2.628V12.5a.75.75,0,0,0,1.5,0v-.557a1.486,1.486,0,0,1,.7-1.314,3,3,0,0,0-.91-5.581Z",
    transform: "translate(-2 -1.25)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3168",
    "data-name": "Rectangle 3168",
    width: 1.096,
    height: 1.096,
    rx: 0.548,
    transform: "translate(8.372 12.664)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfiledropdownHelpcenter);
export default __webpack_public_path__ + "static/media/profiledropdown-helpcenter.e0d1bdc0aaadb9bd27918ea9f7a90a49.svg";
export { ForwardRef as ReactComponent };